import React from 'react';
import Header from './components/Header';
import GuestGrid from './components/GuestGrid';
import JoinSection from './components/JoinSection';
import { guests } from './data/guests';
import { AuroraBackground } from './components/AuroraBackground';
export function App() {
  return <AuroraBackground className="min-h-screen bg-black text-white" data-id="element-0">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-green-900/20 via-black to-black" data-id="element-1"></div>
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.15' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
      filter: 'contrast(320%) brightness(70%)'
    }} data-id="element-2"></div>
      <div className="relative" data-id="element-3">
        <div className="container mx-auto px-4 py-16" data-id="element-4">
          <Header data-id="element-5" />
          <GuestGrid guests={guests} data-id="element-6" />
        </div>
        <JoinSection data-id="element-7" />
      </div>
    </AuroraBackground>;
}